import { z } from 'zod';
import i18next from 'i18next';

/**
 * Login form validation schema
 * Uses Zod for runtime type validation with i18n support
 */
export const loginSchema = z.object({
  email: z
    .string()
    .min(1, { message: () => i18next.t('validation.emailRequired', { ns: 'auth' }) })
    .email({ message: () => i18next.t('validation.emailInvalid', { ns: 'auth' }) }),
  password: z
    .string()
    .min(1, { message: () => i18next.t('validation.passwordRequired', { ns: 'auth' }) })
    .min(6, { message: () => i18next.t('validation.passwordMinLength', { ns: 'auth', min: 6 }) }),
  rememberMe: z.boolean().optional().default(false),
});

export type LoginFormData = z.infer<typeof loginSchema>;
